export default __webpack_public_path__ + "static/media/ExxonMobile.8e27dc0a.png";